<template>
    <div class="horse-edit-main-main-data flex gap-5 mb-3">
        <div class="flex flex-column w-6 gap-3 pb-3 horse-edit-main-main-data-inputs">
            <div class="flex gap-3 w-10">
                <CustomInputText name="name" :label="$t('message.horseEdit.main.name')" required class="w-full"
                                 v-model="horse.name" noPlaceholder :disabled="disableEdit" rules="required"
                                 :disable-brackets="true" force-uppercase/>
<!--                 <CustomInputText name="suffix" class="w-2 p-0" v-model="horse.suffix" noPlaceholder disabled/> -->
            </div>
            <div class="flex gap-3 w-10 align-items-center">
                <CustomInputText name="arabian-name" class="w-full" v-model="horse.localName"
                                 noPlaceholder dir="rtl" :disabled="disableEdit" rules="required"/>
                <div class="arabian-text">:{{ $t('message.horseEdit.main.arabianName') }}*</div>
            </div>
            <CustomSelectOneHorseSex name="sex" :label="$t('message.horseEdit.main.sex')" class="w-10"
                                     v-model="horse.sex" noPlaceholder required
                                     :disabled="disableEdit" rules="required"/>
            <CustomSelectOneHorseColor name="colorId" :label="$t('message.horseEdit.main.colorId')" class="w-10"
                                       v-model="horse.colorId" noPlaceholder :customErrorMessage="validationErrors['colorId'] ? getRequiredMessage(horse.colorId) : null"
                                       itemValue="id" :disabled="disableEdit" :required="requiredForNotExternalHorse" :rules="requiredForNotExternalHorse ? 'required' : ''"
                                       @validationResult="passColorValidationResult"
                                       :damColorName="horse.damColorName" :sireColorName="horse.sireColorName"/>
            <CustomInputText v-if="!horse.imported" name="registryNumber" :label="$t('message.horseEdit.main.registryNumber')" class="w-10"
                             v-model="horse.studbookRegistryId" noPlaceholder disabled
                             :disabled="true"/>
            <CustomInputText name="ueln" :label="$t('message.horseEdit.main.ueln')" :required="requiredForNotExternalHorse"
                             class="w-10"
                             v-model="horse.ueln" noPlaceholder :disabled="!(imported || horse.imported) || disableEdit"
                             :max-length="15" />
            <CustomInputText name="transponderCode" :label="$t('message.horseEdit.main.transponderCode')" class="w-10" :required="requiredForNotExternalHorse"
                             v-model="horse.transponderCode" noPlaceholder
                             :rules="fifteenCharsRules"
                             :max-length="15"
                             :disabled="disableEdit"/>
            <CustomInputText name="secondTransponderCode" :label="$t('message.horseEdit.main.secondTransponderCode')" class="w-10"
                             v-model="horse.secondTransponderCode" noPlaceholder
                             :disabled="disableEdit"/>
<!--            <div class="origin-checkboxes flex gap-5" v-if="!imported">-->
<!--                <CustomCheckbox name="imported" :label="$t('message.horseEdit.main.imported')"-->
<!--                                v-model="horse.imported" noPlaceholder :disabled="true"/>-->
<!--                <CustomCheckbox name="locallyBreed" :label="$t('message.horseEdit.main.locallyBreed')"-->
<!--                                v-model="horse.locallyBreedlocallyBreed" noPlaceholder :disabled="true"/>-->
<!--            </div>-->
        </div>
        <div class="separator"/>
        <div class="w-6 flex flex-column align-items-center gap-3 mt-3">
            <div class="horse-photo-container">
                <img :src="horse.photoUrl ? horse.photoUrl : getHorsePhoto()"
                     :alt="$t('message.horsePreview.horsePhoto')" class="horse-photo">
            </div>
            <input type="file" ref="file" v-show="false" @change="handleFile"
                   id="importFile" name="file" accept="image/*"/>
            <div v-if="horse.photoUrl"><CustomTextButton :label="$t('message.horseEdit.main.deletePhotoButton')" @click="deleteAvatar()" :disabled="disableEdit"/></div>
            <div v-else>
                <CustomTextButton :label="$t('message.horseEdit.main.addPhotoButton')" @click="$refs.file.click()" :disabled="disableEdit"/>
            </div>
        </div>
    </div>
</template>

<script>
import {ref} from "vue";
import Toast from "primevue/toast";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomInputTextArea from "@/components/form/CustomInputTextArea.vue";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomSelectOneHorseSex from "@/components/form/CustomSelectOneHorseSex.vue";
import CustomSelectOneHorseColor from "@/components/form/CustomSelectOneHorseColor.vue";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import {deleteHorseAvatar} from "@/swagger/vue-api-client";
import {HorseStatus} from "@/utils/HorseStatus";

export default {
    name: "HorseEditMainMainData",
    components: {
        CustomTextButton,
        CustomSelectOneHorseColor,
        CustomSelectOneHorseSex,
        CustomInputNumber,
        CustomCheckbox,
        CustomSelectOne,
        CustomInputText,
        CustomInputTextArea,
        CustomButton,
        Toast,
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            default: {},
        },
        imported: {
            type: Boolean,
            default: false,
        },
        locallyBreed: {
            type: Boolean,
            default: false,
        },
        disableEdit: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            importedPhoto: null,
            files: [],
            waitForServer: false,
        };
    },

    setup() {
        const active = ref(false);

        const toggleActive = () => {
            active.value = !active.value;
        };

        return {
            active,
            toggleActive,
        };
    },

    emits: ["update:modelValue", "importPhoto", "color-validation-result"],

    mounted() {
        if (this.imported) {
            this.horse.imported = true;
            this.horse.locallyBreed = false;
        }
        if (this.locallyBreed) {
            this.horse.imported = false;
            this.horse.locallyBreed = true;
        }
    },

    methods: {
        getHorsePhoto() {
            if (document.body.classList.contains("arab-horses")) return require("../../../../../assets/horse-graphic.png");
            return require("../../../../../assets/Preview-Image-thoroughbred.jpg")
        },
        getRequiredMessage(value) {
            if (value === null || value === "" || value === undefined) {
                return this.$t("message.validations.required");
            }
            return "";
        },
        deleteAvatar() {
            deleteHorseAvatar({horseId: this.horse.id}).then(() => {
                this.horse.photoUrl = null;
                this.$toast.add({
                    severity: "success",
                    summary: this.$t("message.other.success"),
                    detail: this.$t("message.other.avatarDeleted"),
                    life: 3000,
                });
            })
        },
        notifyDelete() {
            this.$toast.add({
                severity: "success",
                summary: this.$t("message.other.success"),
                detail: this.$t("message.other.elementDeleted"),
                life: 3000,
            });
        },
        notifyError(error) {
            const message = error.response?.data?.message || this.$t("unknownError");
            this.$toast.add({
                severity: "error",
                summary: this.$t("message.other.error"),
                detail: message,
                life: 5000,
            });
        },
        handleFile() {
            const file = this.$refs.file.files[0];

            if (!file) return;

            const reader = new FileReader();

            reader.onload = function (e) {
                const img = document.querySelector(".horse-photo");
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);

            const formData = new FormData();

            formData.append("files", file);

            this.horse.importedPhoto = formData;

            this.$emit("importPhoto", formData);
        },
        addPhoto() {

        },
        passColorValidationResult(isValid) {
            this.$emit('color-validation-result', isValid);
        },
    },

    computed: {
        horse: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
        requiredForNotExternalHorse() {
            return this?.horse?.horseStatus !== HorseStatus.EXTERNAL;
        },
        fifteenCharsRules() {
            const rules = [];

            if (this.requiredForNotExternalHorse) {
                rules.push(v => !!v || this.$t('message.validations.required'));
            }

            rules.push(v => !v || v.length === 15 || this.$t('message.validations.exactly_15_characters'));

            return rules;
        }
    },
};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";

.horse-edit-main-main-data {
    .arabian-text {
        font-size: 20px;
    }

    .custom-input-text, .custom-input-number, .custom-select-one {
        padding-left: 170px;
        .custom-label {
            z-index: 999;
            position: absolute;
            transform: translateX(-100%);
            left: 160px;
            text-align: right;
        }
    }

    .origin-checkboxes {
        padding-left: 170px;
    }

    .horse-photo-container {
        position: relative;
        .horse-photo {
            height: auto;
            width: 100%;
            background: var(--primary-color);
            border-radius: 12px;
        }
    }
    .separator {
        width: 1.5px;
        background-color: var(--separator-color);
    }

    .file-label {
        color: var(--text-color);
        text-transform: uppercase;
        font-weight: 600;
        cursor: pointer;
    }

    @media screen and (max-width: 1600px) {
        .horse-edit-main-main-data-inputs {
            align-items: end;
            .custom-input-text, .custom-input-number, .custom-select-one {
                padding-left: 80px;
                .custom-label {
                    left: 70px;
                }
            }
        }
    }

    @media screen and (max-width: 1000px) {
        flex-direction: column;
        align-items: center;
        .horse-edit-main-main-data-inputs {
            width: 90% !important;
            align-items: center;
        }
        .origin-checkboxes {
            padding-left: 0;
        }
    }
}

body.arab-horses {
    .horse-edit-main-main-data {
        .horse-photo-container {
            position: relative;
            .horse-photo {
                height: 350px;
                width: unset;
                background: var(--primary-color);
                border-radius: 12px;
            }
        }
    }
}
</style>
